var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement } from 'lit/decorators.js';
import { LitElement, html } from 'lit';
import { facebookSvg, instagramSvg, linkedInSvg, youtubeSvg, } from '../../helpers/elements.js';
const socialsIconClasses = 'w-[24px] h-[24px]';
const SOCIALS = [
    {
        url: 'https://instagram.com/schweizmobil/',
        svg: instagramSvg(socialsIconClasses),
    },
    {
        url: 'https://facebook.com/SchweizMobil/',
        svg: facebookSvg(socialsIconClasses),
    },
    {
        url: 'https://ch.linkedin.com/company/schweizmobil',
        svg: linkedInSvg(socialsIconClasses),
    },
    {
        url: 'https://youtube.com/@stiftungschweizmobil5551',
        svg: youtubeSvg(socialsIconClasses),
    },
];
let ElementB2bSocials = class ElementB2bSocials extends LitElement {
    render() {
        return html `
      <div class="flex h-[40px] items-center gap-x-[14px]">
        ${SOCIALS.map((social) => html `
            <a
              class="fill-white rounded-full transition duration-300 hover:bg-chm-focus-red p-[8px]"
              href=${social.url}
              target="_blank"
            >
              ${social.svg}
              <span class="screen-reader-only"
                >(s\u2019ouvre dans un nouvel onglet)</span
              >
            </a>
          `)}
      </div>
    `;
    }
    createRenderRoot() {
        return this;
    }
};
ElementB2bSocials = __decorate([
    customElement('element-b2b-socials')
], ElementB2bSocials);
export { ElementB2bSocials };
//# sourceMappingURL=element-b2b-socials.js.map